import React, { useState, useEffect } from 'react'
import Footer from '../components/Complements/Footer';
import LoadingScreen from '../components/Complements/LoadingScreen';
import StandardDialog from '../components/Complements/StandardDialog';
import Dashboard from '../components/Menu/Dashboard';
import { Grid, CircularProgress, IconButton, Typography, makeStyles } from '@material-ui/core';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import { feathersFindDataAllDefault, feathersCreateData } from '../services';
import Pagination from '@material-ui/lab/Pagination';
import Alert from '@material-ui/lab/Alert';
import Title from './../components/Complements/Title';
import BeneficiaryOwnFormEdit from '../components/Complements/BeneficiaryOwnFormEdit';
import { encrypt } from '../functions/mobile';
import { withRouter } from 'react-router-dom'
import { connect } from "react-redux";
import { changeAliasAccount } from '../actions/consolidates';


const useStyles = makeStyles((theme) => ({
    buttonViewMovements: {
        [theme.breakpoints.up('xs')]: {
            color: '#0073D2',
            fontSize: '70%',
            //fontFamily: 'HelveticaNeuelTstdMdcn',
        },
        [theme.breakpoints.up('sm')]: {
            color: '#0073D2',
            fontSize: '80%',
            //fontFamily: 'HelveticaNeuelTstdMdcn',
        },
        [theme.breakpoints.up('md')]: {
            color: '#0073D2',
            fontSize: '80%',
            //fontFamily: 'HelveticaNeuelTstdMdcn',
        },
        [theme.breakpoints.up('lg')]: {
            color: '#0073D2',
            fontSize: '80%',
            //fontFamily: 'HelveticaNeuelTstdMdcn',
        },
        [theme.breakpoints.up('xl')]: {
            color: '#0073D2',
            fontSize: '80%',
            //fontFamily: 'HelveticaNeuelTstdMdcn',
        },
    },

}));

const AccountAdministrationContainer = props => {

    const { devices, handleOpenSnack } = props

    const classes2 = useStyles()

    const [accountsPaginate, setAccountsPaginate] = useState([])
    const [page, setPage] = useState(1)
    const [count, setCount] = useState(1)
    const [loading, setLoading] = useState(false)
    const [dialog, setDialog] = useState({
        open: false,
        data: {}
    })

    const mount = () => {
        const unmount = () => {

            handleGetDataAccount(0, 1)
        }
        return unmount()
    }

    useEffect(mount, [])

    const handleGetDataAccount = async(rows, numberpage) => {

        setLoading(true)

        try {
            
            const responseDataAccounts = await feathersFindDataAllDefault("users-default", {
                $limit: 10,
                $skip: rows,
                state: true,
                beneficiary: "PROPIA",
                $sort: {
                    createdAt: -1
                }
            })()

            const { data, total } = responseDataAccounts

            setAccountsPaginate(data)

            getDataViewTable(total, numberpage)

            setLoading(false)

        } catch (error) {
            //console.log(error)
            setLoading(false)
        }

    }

    const handleChangeAlias = async(values) => {

        try {
            
            //console.log(values)

            const { ip, device, mac } = devices

            const sendDataAddBeneficiary = encrypt(JSON.stringify({
                action : "UPDATE_BENEFICIARY",
                dataUsersDefault: {
                    ...values
                },
                dataDevice : {
                    ip,
                    mac,
                    device,
                },
                type : 31,
                otp : ""
            }))

            const responseCreateBeneficiary = await feathersCreateData("procces-users-default", { sendData  : sendDataAddBeneficiary})()

            if (responseCreateBeneficiary.error === false) {
                handleGetDataAccount(0, 1)
                props.changeAliasAccount({
                    numeroCuenta: values.number,
                    alias : values.alias.toUpperCase()
                })
                handleOpenSnack(responseCreateBeneficiary.message, 'success')
                handleCloseDialogChangeAlias()
            }else{
                handleOpenSnack(responseCreateBeneficiary.message, 'error')
            }

            setLoading(false)
        } catch (error) {
            //console.log(error)
            handleOpenSnack("Ha ocurrido un error al actualizar la información", 'error')
            setLoading(false)
        }

        
    }

    const handleCloseDialogChangeAlias = () => {
        setDialog({
            open: false,
            data : {}
        }) 
    }

    const renderBody = () => {

        return <div>
            <Grid container spacing={3}>
                <Grid item xs={12} md={8} lg={8} sm={12}>
                    <Title>Administración de Cuentas</Title>
                </Grid>
                <Grid item xs={12} md={4} lg={4} sm={12}>

                </Grid>
            </Grid>
            <Grid container spacing={3} justify="center" alignItems="center">
                {renderTableAccounts()}
            </Grid>
        </div>
    }

    const handleEditData = (item) => {

        setDialog({
            open: true,
            data : item
        }) 
    }

    const renderTableAccounts = () => {

        if (loading) {
            return <CircularProgress />
        } else {
            if (accountsPaginate.length > 0) {
                return <div className={"container"}>
                    <Grid item xs={12} md={12} lg={12}>
                        <Table className={"table"}>
                            <Thead>
                                <Tr>
                                    <Th># de Cuenta</Th>
                                    <Th>Alias</Th>
                                    <Th>Tipo</Th>
                                    <Th>Opciones</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {

                                    accountsPaginate.map(row => (
                                        <Tr key={`${row.number}`}>
                                            <Td>{row.number}</Td>
                                            <Td>{row.alias}</Td>
                                            <Td>{row.type_name}</Td>
                                            <Td>
                                                <IconButton edge="end" aria-label="delete" onClick={() => handleEditData(row)}>
                                                    <Typography className={classes2.buttonViewMovements} align="left">
                                                        EDITAR
                                                    </Typography>
                                                </IconButton>
                                            </Td>
                                        </Tr>
                                    ))

                                }

                            </Tbody>
                        </Table>
                        <Pagination
                            count={count}
                            color="primary"
                            page={page}
                            onChange={onChangePaginationCodes}
                        />
                    </Grid>
                </div>
            } else {
                return <Alert severity="info">No se han encontrado cuentas.</Alert>
            }
        }
    }

    const getDataViewTable = (total, numberpage) => {
        // console.log("*** CODES ***", codes)
        let contador = parseInt((total / 10).toString());
        let residuo = total % 10;

        if (residuo > 0) {
            contador++;
        }

        setCount(contador)
        setPage(numberpage)
    }

    const onChangePaginationCodes = (e, numberpage) => {
        handleGetDataAccount((numberpage - 1) * 10, numberpage)
    }

    const handleCLoseDialog = () => {
        setDialog({ ...dialog, open: false })
    }

    return (
        <div>
            <LoadingScreen open={loading} />
            <Dashboard
                title= ""
                body = { renderBody() }
                multiple = { false }
            />
            <Footer />
            <StandardDialog
                handleClose={handleCLoseDialog}
                open={dialog.open}
                title={dialog.title}>
                {dialog.children}
            </StandardDialog>
            <BeneficiaryOwnFormEdit
                ownBeneficiary={dialog}
                onAcceptClick={ handleChangeAlias }
                onCloseBeneficiaryForm={ handleCloseDialogChangeAlias }
            />
        </div>
    )
}

export default withRouter(connect(null, {
    changeAliasAccount
} )(AccountAdministrationContainer))
